<template>
  <div @dragstart.prevent :class="[
    'el-input-number',
    inputNumberSize ? 'el-input-number--' + inputNumberSize : '',
    { 'is-disabled': inputNumberDisabled },
    { 'is-without-controls': !controls },
    { 'is-controls-right': controlsAtRight },
    { 'under-line': underLineStyle },
    { 'text-cursor': textCursor },
    { 'is-focus': isFocus },
  ]">
    <slot name="prefix" v-if="$slots.prefix"></slot>
    <div class="input-row-number-box">
      <el-input class="input-number-box" :style="{
        textAlign: 'inherit',
      }" :class="{ 'input-controls': showControls && !disabled }" ref="input" :value="displayValue"
        :placeholder="placeholder" :disabled="inputNumberDisabled" :size="inputNumberSize" :max="max" :min="min"
        :name="name" :label="label" v-bind="$attrs" @keydown.up.native.prevent="increase" :clearable="false"
        @keydown.down.native.prevent="decrease" @blur="handleBlur" @focus="handleFocus" @input="handleInput"
        @change="handleInputChange"></el-input>
      <div class="number__arrowbox" v-if="showControls && !disabled">
        <span class="el-input-number__decrease" role="button" v-if="controls" v-repeat-click="decrease"
          :class="{ 'is-disabled': minDisabled }" @keydown.enter="decrease">
          <i :class="`el-icon-${controlsAtRight ? 'arrow-down' : 'minus'}`"></i>
        </span>
        <span class="el-input-number__increase" role="button" v-if="controls" v-repeat-click="increase"
          :class="{ 'is-disabled': maxDisabled }" @keydown.enter="increase">
          <i :class="`el-icon-${controlsAtRight ? 'arrow-up' : 'plus'}`"></i>
        </span>
      </div>
    </div>
    <div v-if="$slots.suffix" class="suffix-cls">
      <slot name="suffix"></slot>
    </div>
  </div>
</template>
<script>
/**
 * 数值输入组件，右边有上下控制图标,
 * 
 */
//  <template #prefix v-if="$slots.prefix">
//       <!-- 前置内容 -->
//       <slot name="prefix"></slot>
//     </template>
//     <template #suffix v-if="$slots.suffix">
//       <!-- 后置内容 -->
//       <slot name="suffix"></slot>
//     </template>
//     <template v-if="$slots.append">
//       <!-- 后置元素 -->
//       <slot name="append"></slot>
//     </template>


import ElInput from "element-ui/packages/input";
import Focus from "element-ui/src/mixins/focus";
import RepeatClick from "element-ui/src/directives/repeat-click";
import calculate from "./mixin/calculate.js";

function cbParseNumber(value, localPrecisionNumber) {
  let val = value;
  if (value !== undefined && value !== null && value !== "") {
    val = toStringFs(value);

    const regString = `^\\D*(\\d*(?:\\.\\d{0,${localPrecisionNumber}})?).*$`; ///^\D*(\d*(?:\.\d{0,3})?).*$/g
    const regExp = new RegExp(regString, "g");
    val = val.replace(regExp, "$1");
    if (!localPrecisionNumber && val) {
      //去除数组后面 英文句号.
      val = +val;
    }
  }

  return val;
}

function toStringFs(value) {
  if (typeof value === "number") {
    value = String(value);
  }
  return value;
}

export default {
  name: "ElInputNumber",
  mixins: [Focus("input"), calculate],
  inject: {
    elForm: {
      default: "",
    },
    elFormItem: {
      default: "",
    },
  },
  directives: {
    repeatClick: RepeatClick,
  },
  components: {
    ElInput,
  },
  props: {
    //文本光标
    textCursor: { type: Boolean, default: () => false },

    underLineStyle: {
      type: Boolean,
      default: () => false,
    },
    step: {
      // 计数器步长
      type: Number,
      default: 1,
    },
    stepStrictly: {
      // 是否只能输入 step 的倍数
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true,
    },
    controlsPosition: {
      type: String,
      default: "right",
    },
    name: String,
    label: String,
    placeholder: String,
    precision: {
      // 数值精度
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      },
    },
    rounding: {
      //是否四舍五入
      type: Boolean,
      default: true,
    },
    showControls: {
      //是否展示箭头控制器
      type: Boolean,
      default: false,
    },
    dispPrecision: {
      // 显示数值精度,当小数点后面的0保留位数1.2000  => 1.20;  1.333 => 1.333;  1.000 => 1.00;
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      },
      default: () => 0,
    },
  },
  data() {
    return {
      isFocus: false,
      currentValue: 0,
      userInput: null,
    };
  },
  watch: {
    value: {
      immediate: false, //改成false，结合created里头的handlerOutValueChange()初始,避免 引起外头立即计算
      handler(value) {
        this.handlerOutValueChange(value);
      },
    },
  },
  computed: {
    minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision() {
      const { value, step, getPrecision, precision } = this;
      const stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn("[Element Warn][InputNumber]precision should not be less than the decimal places of step");
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight() {
      return this.controls && this.controlsPosition === "right";
    },
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled() {
      return this.disabled || !!(this.elForm || {}).disabled;
    },
    displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }
      let currentValue = this.currentValue;
      if (typeof currentValue === "number") {
        if (this.stepStrictly) {
          const stepPrecision = this.getPrecision(this.step);
          const precisionFactor = Math.pow(10, stepPrecision);
          currentValue = (Math.round(currentValue / this.step) * precisionFactor * this.step) / precisionFactor;
        }
        if (this.precision !== undefined) {
          currentValue = this.rounding ? currentValue.toFixed(this.precision) : this.fixNumber(currentValue, this.precision);
        }
        //小数点后面显示的0数量
        if (this.dispPrecision !== undefined && this.dispPrecision < this.precision && `${+currentValue}` !== `${currentValue}`) {
          let newVal = `${+currentValue}`; //去除后面的0的字符串
          let v2 = newVal.split(".");
          let tail = v2[1] ? v2[1] : "";
          while (tail.length < this.dispPrecision) {
            tail += "0";
          }
          if (tail) {
            currentValue = `${v2[0]}.${tail}`;
          } else {
            currentValue = `${v2[0]}`;
          }
        }
      }
      return currentValue;
    },
  },
  methods: {
    //notifyOut 第一次由外部传入，那么就不要去通知外头
    handlerOutValueChange(value, notifyOut = true) {
      if (value === "") {
        this.currentValue = value;
        this.userInput = value;
        notifyOut && this.$emit("input", value);
        return;
      }
      let newVal = value === undefined ? value : Number(value);
      if (newVal !== undefined) {
        if (isNaN(newVal)) {
          return;
        }
        if (this.stepStrictly) {
          const stepPrecision = this.getPrecision(this.step);
          const precisionFactor = Math.pow(10, stepPrecision);
          newVal = (Math.round(newVal / this.step) * precisionFactor * this.step) / precisionFactor;
        }
        if (this.precision !== undefined) {
          newVal = this.toPrecision(newVal, this.precision);
        }
      }
      if (notifyOut) {
        //notifyOut false 说明是第一次初始化,初始化的数据可能不在【最小值或最大值】范围内，
        //所有第一次初始化不做重新赋值，否则导致 箭头操作 不能处理的情况
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
      }

      this.currentValue = newVal;
      this.userInput = null;
      notifyOut && this.$emit("input", newVal);
    },
    toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      if (!this.rounding) {
        //return Math.floor(num * Math.pow(10,precision)) / Math.pow(10,precision);
        return this.fixNumber(num, precision);
      }
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    getPrecision(value) {
      if (value === undefined) return 0;
      const valueString = value.toString();
      const dotPosition = valueString.indexOf(".");
      let precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase(val, step) {
      if (typeof val === "string") {
        let _val = Number(val);
        !isNaN(_val) && (val = _val);
      }
      if (typeof val !== "number" && val !== undefined) return this.currentValue;
      const precisionFactor = Math.pow(10, this.numPrecision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease(val, step) {
      if (typeof val === "string") {
        let _val = Number(val);
        !isNaN(_val) && (val = _val);
      }
      if (typeof val !== "number" && val !== undefined) return this.currentValue;
      const precisionFactor = Math.pow(10, this.numPrecision);
      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      const value = this.value || 0;
      const newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      const value = this.value || 0;
      const newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur(event) {
      this.isFocus = false;
      this.$emit("blur", event);
    },
    handleFocus(event) {
      this.isFocus = true;
      this.$emit("focus", event);
    },
    setCurrentValue(newVal) {
      const oldVal = this.currentValue;
      if (typeof newVal === "number" && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit("input", newVal);
      this.$emit("change", newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput(value) {
      //不允许非数字输入
      let localPrecisionNumber = this.precision > 0 ? this.precision : 0;
      let val = cbParseNumber(value, localPrecisionNumber);

      this.userInput = val;
    },
    handleInputChange(value) {
      //小于最小值，直接赋值为空
      if (+value < this.min) {
        value = "";
      }
      const newVal = value === "" ? undefined : Number(value);
      if (!isNaN(newVal) || value === "") {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select() {
      this.$refs.input.select();
    },
    focus() {
      this.$refs.input.focus();
      this.$refs.input.select();
    },
  },
  created() {
    this.handlerOutValueChange(this.value, false);
  },
  mounted() {
    let innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute("role", "spinbutton");
    innerInput.setAttribute("aria-valuemax", this.max);
    innerInput.setAttribute("aria-valuemin", this.min);
    innerInput.setAttribute("aria-valuenow", this.currentValue);
    innerInput.setAttribute("aria-disabled", this.inputNumberDisabled);
  },
  updated() {
    if (!this.$refs || !this.$refs.input) return;
    const innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute("aria-valuenow", this.currentValue);
  },
};
</script>

<style scoped lang="scss">
.el-input-number {
  position: relative;
  display: flex;
  align-items: center;
  height: inherit;

  &.is-controls-right {
    .el-input-number__decrease {
      i.el-icon-arrow-down {
        border-radius: 0 0 2px 2px;
      }
    }

    .el-input-number__increase {
      i.el-icon-arrow-up {
        border-radius: 2px 2px 0 0;
      }
    }

    .number__arrowbox {
      flex-shrink: 0;
      position: absolute;
      height: 30px;
      width: 14px;
      z-index: 0;
      right: 1px;
      top: 50%;
      margin-top: -15px;
    }

    .el-input-number__increase,
    .el-input-number__decrease {
      width: 14px;
      height: 14px !important;
      line-height: 14px !important;
      transform: none;

      .el-icon-arrow-down,
      .el-icon-arrow-up {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        transform: none;
        width: 14px;
        display: block;
        margin: 0 auto;
        background: #f2f6f9;
        color: #aeb7bf;

        &:before {
          // 箭头
          font-size: 14px;
        }

        &:hover {
          background: #d7dce0;
          color: #77828c;
        }
      }
    }

    ::v-deep .el-input__inner {
      padding-left: 10px;
      padding-right: 20px;
    }

  }

  .suffix-cls {
    flex: 1;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
  }

  &.is-disabled {

    .el-input-number__decrease,
    .el-input-number__increase {
      display: none;
    }

    &.text-cursor {
      ::v-deep .el-input__inner {
        cursor: text;
      }
    }
  }

  .input-row-number-box {
    position: relative;
    display: flex;
    align-items: center;
    height: inherit;

    .el-input-number__decrease,
    .el-input-number__increase {
      display: none;
      //display: block;
    }

    &:hover {

      .el-input-number__decrease,
      .el-input-number__increase {
        display: block;
      }

      .input-controls ::v-deep {}
    }
  }

  .input-number-box {
    height: inherit;
    z-index: 0;

    ::v-deep {
      .el-input__inner {
        height: inherit;
        text-align: right;
      }
    }
  }
}
</style>
